import { BundleWindow, NewBundleWindow } from "./BundleWindow";
import { usePriceList } from "./data";
import { GroupWindow } from "./GroupWindow";
import { ItemWindow } from "./ItemWindow";
import { NewItemWindow } from "./NewItemWindow";
import { NewSupplierWindow, SupplierWindow } from "./SupplierWindow";
import { WINDOW_KINDS } from "./meta";
import { usePriceListWindows } from "./windows";

/*
 * The Price List's windows, over whatever page is showing (the app draws this on every page while
 * the address has one: see windows.ts). The Price List's data loads only while one is open.
 */

export default function PriceListWindowHost() {
    const { params } = usePriceListWindows();
    return WINDOW_KINDS.some((kind) => params.has(kind)) ? <OpenWindows /> : null;
}

function OpenWindows() {
    const { data } = usePriceList();
    const windows = usePriceListWindows();
    const { params, set } = windows;
    if (!data) return null;
    const item = params.get("item");
    const supplier = params.get("supplier");
    const bundle = params.get("bundle");
    const group = params.get("group");

    return (
        <>
            {item === "new" && <NewItemWindow onClose={() => set({ item: null })} onCreated={(uuid) => set({ item: uuid, itemTab: "pricing" })} />}
            {item && item !== "new" ? (
                <ItemWindow
                    data={data}
                    uuid={item}
                    tab={params.get("itemTab") ?? "details"}
                    onTab={(t) => set({ itemTab: t })}
                    onClose={() => set({ item: null, itemTab: null })}
                />
            ) : null}
            {supplier === "new" && <NewSupplierWindow data={data} onClose={() => set({ supplier: null })} onCreated={(uuid) => set({ supplier: uuid, supplierTab: "details" })} />}
            {supplier && supplier !== "new" ? (
                <SupplierWindow
                    data={data}
                    uuid={supplier}
                    tab={params.get("supplierTab") ?? "details"}
                    onTab={(t) => set({ supplierTab: t })}
                    onClose={() => set({ supplier: null, supplierTab: null })}
                    onOpenItem={(uuid) => windows.openItem(uuid)}
                />
            ) : null}
            {bundle === "new" && <NewBundleWindow data={data} onClose={() => set({ bundle: null })} onCreated={(uuid) => set({ bundle: uuid, bundleTab: "contents" })} />}
            {bundle && bundle !== "new" ? (
                <BundleWindow
                    data={data}
                    uuid={bundle}
                    tab={params.get("bundleTab") ?? "details"}
                    onTab={(t) => set({ bundleTab: t })}
                    onClose={() => set({ bundle: null, bundleTab: null })}
                    onOpenItem={(uuid) => windows.openItem(uuid)}
                />
            ) : null}
            {group ? (
                <GroupWindow
                    data={data}
                    id={group}
                    tab={params.get("groupTab") ?? "details"}
                    onTab={(t) => set({ groupTab: t, rename: null })}
                    onClose={() => set({ group: null, groupTab: null, rename: null })}
                    rename={params.has("rename")}
                    onOpenItem={(uuid) => windows.openItem(uuid)}
                />
            ) : null}
        </>
    );
}
